import { z } from "zod";
import { localStore } from "../../../lib/store";

/**
 * Per-device native UX opt-outs for iOS/Android webview users. Not synced to
 * the server — storage-local preferences driven by the settings page.
 */
export const disableSoundStore = localStore("disableSound", false, z.boolean());

export const disableHapticStore = localStore(
  "disableHaptic",
  false,
  z.boolean()
);
